<template>
  <validation-observer
    id="interiorDesignerForm"
    ref="interiorDesignerForm"
    tag="form"
    class="page_container_wrapper"
    novalidate
    @submit.prevent="handleSubmit"
  >
    <transition name="fade-in-up">
      <div v-if="!showThanksPage" class="page_container">
        <step-intro :step.sync="form.intro"></step-intro>

        <vvs-recaptcha
          v-if="showRecaptcha"
          name="Google Recaptcha"
          validate="required"
          v-model="googleVerifyKey"
          style="margin-top:75px"
        ></vvs-recaptcha>

        <div style="margin-top:75px">
          <vvs-submit-button
            title="BAŞVURUYU TAMAMLAYIN"
            description="* doldurulması zorunlu alan"
          ></vvs-submit-button>
        </div>
      </div>
      <step-thanks v-else></step-thanks>
    </transition>
  </validation-observer>
</template>

<script>
import StepIntro from './intro/';
import packageInfo from './intro/package-info';
import StepThanks from './thanks/';

export default {
  name: 'ApplicationsInteriorDesignerSteps',
  components: {
    StepIntro,
    StepThanks,
  },
  data() {
    return {
      googleVerifyKey: null,
      showRecaptcha: true,
      form: {},
      showThanksPage: false,
    };
  },
  computed: {
    steps() {
      return this.$store.getters['interiorDesigner/getAllSteps'];
    },
  },
  methods: {
    async handleSubmit() {
      const isValid = await this.$refs.interiorDesignerForm.validate();

      if (isValid) {
        await this.$store.commit('setIsAppLoading', true);
        await this.$store.dispatch('interiorDesigner/createApplication', {
          application: {
            items: this.getStepsForSave(),
          },
        });
        await this.$store.commit('setIsAppLoading', false);
        this.showThanksPage = true;
      }
      this.setNotify({ isValid });
    },
    getStepsForSave() {
      let form = JSON.parse(JSON.stringify(this.form));

      form.intro.packageInfo = packageInfo
        .filter(item => {
          return item.parent === form.intro.packageCollection;
        })
        .map(item => item.text)
        .join();

      return [form.intro];
    },
    setNotify({ isValid }) {
      if (isValid) {
        this.$notify({
          title: 'İç Mimarlık Başvuru Formu',
          text: 'Form başarıyla kaydedildi',
          type: 'success',
        });
        setTimeout(() => {
          this.$scrollTo('body');
        });
      } else {
        this.$notify({
          title: 'İç Mimarlık Başvuru Formu',
          text: 'Lütfen formdaki bütün zorunlu alanları doldurunuz.',
          type: 'danger',
          ignoreDuplicates: true,
        });
        setTimeout(() => {
          this.$scrollTo('.form_group_wrapper__error', { offset: -20 });
        });
      }
    },
  },
  watch: {
    steps: {
      handler() {
        this.form = JSON.parse(JSON.stringify(this.steps));
      },
      deep: true,
    },
  },
  created() {
    this.form = JSON.parse(JSON.stringify(this.steps));
  },
};
</script>
